import { ApplicationRootState } from 'redux-core/types';
import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectAdminLocales = (state: ApplicationRootState) =>
    state.admin.locales || initialState;

export const selectLocalesList = createSelector(
    selectAdminLocales,
    (state) => state.list
);

export const selectLocalesOptions = createSelector(
    selectLocalesList,
    (locales) => {
        return locales.data?.map((locale) => ({
            label: locale.name,
            value: locale.id,
        }));
    }
);
